import React from 'react';
import { createRoot } from 'react-dom/client';
import { AppRegistry } from 'react-native';
import App from './App';
import './globals.css';

/**
 * WasteLinQ Web Entry Point
 *
 * Initializes React Native Web and renders the root App component
 * with all necessary providers and configuration.
 */

// Register the app with React Native's AppRegistry
AppRegistry.registerComponent('WasteLinq', () => App);

// Get the root element
const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element not found. Make sure there is a <div id="root"></div> in your HTML.');
}

// Create React root and render the app
const root = createRoot(rootElement);

// Render the app
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Service Worker registration for offline support
if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .then((registration) => {
        console.log('Service Worker registered:', registration);
      })
      .catch((error) => {
        console.error('Service Worker registration failed:', error);
      });
  });
}

// Web Notifications API permission request
if ('Notification' in window && Notification.permission === 'default') {
  // Request will be made on first user interaction
  document.addEventListener('click', () => {
    Notification.requestPermission().then((permission) => {
      console.log('Notification permission:', permission);
    });
  }, { once: true });
}

// Error boundary for unhandled errors
window.addEventListener('error', (event) => {
  console.error('Global error:', event.error);
});

window.addEventListener('unhandledrejection', (event) => {
  console.error('Unhandled promise rejection:', event.reason);
});
